
export default function getText(props: {fr: string, en: string, language: string,}) {
  switch(props.language) {
    case 'FR': return props.fr;
    default: return props.en;
  }
}